import { MaterialCommunityIcons } from '@expo/vector-icons';

import type { Icon } from './internal';

export const Stethoscope: Icon = ({ color = '#000000', size = 24 }) => (
  <MaterialCommunityIcons name="stethoscope" size={size} color={color} />
);
